import connectApi from 'api/connectApi'
import {
    constants,
    internetConnect,
    sendMessageToWorker,
    sendMessageToWorkerWithResponse
} from 'helpers'
import { ErrorResponse } from 'types'
import * as Sentry from '@sentry/react'

export const getCardInventory = async (veCode: string) => {
    const internetConnection = internetConnect()

    const { fetchedData } = await sendMessageToWorkerWithResponse({
        'get ve card inventory': ''
    })

    if (!internetConnection && !fetchedData) {
        return 'No internet connection'
    }

    if (!internetConnection && fetchedData) {
        return fetchedData
    }

    return fetchCardInventoryFromServer(veCode)
}

const fetchCardInventoryFromServer = async (veCode: string) => {
    try {
        const { data: veCardInventoryResponse } = await connectApi.get(
            constants.endpoints.VE_CARD_INVENTORY,
            {
                params: { code: veCode }
            }
        )

        sendMessageToWorker({
            'store ve card inventory': {
                veCardInventory: veCardInventoryResponse,
                veCode
            }
        })

        return veCardInventoryResponse
    } catch (error: unknown) {
        const isOnline = internetConnect()
        const responseError =
            error instanceof ErrorResponse && error.response.data.message
        const errorToReturn = responseError || 'An error occured'

        if (isOnline && responseError) {
            Sentry.captureException(responseError)
        }

        return errorToReturn
    }
}
